export function createLoadKanbanDashboard({ kanbanGateway }) {
  return {
    async execute({ page = 1, limit = 100, status = '', cliente = '', search = '' } = {}) {
      const response = await kanbanGateway.list({
        page,
        limit,
        status,
        cliente,
        search,
      });

      if (Array.isArray(response)) {
        return {
          items: response,
          total: response.length,
          totalPages: response.length ? 1 : 0,
          page,
        };
      }

      return {
        items: response.items || [],
        total: response.total || 0,
        totalPages: response.totalPages || 0,
        page: response.page || page,
      };
    },

    async getDiagnostics() {
      const response = await kanbanGateway.getSyncDiagnostics();

      return {
        latest: response.latest || null,
      };
    },
  };
}
